function DisclaimerTrigger({ onClick }) {
  return (
    <button
      className="hover:text-link whitespace-nowrap block p-2 dark:hover:text-white dark:hover:underline"
      onClick={onClick}
    >
      Legal Disclaimer
    </button>
  );
}

export default DisclaimerTrigger;
